/**
 * Created by Mark on 17/04/2017.
 */

import React from 'react';
import {FormGroup , FormControl , Breadcrumb , Col , Button , Row , Media , Badge , Navbar , NavDropdown , MenuItem , Nav , NavItem , Panel} from 'react-bootstrap';
import VocabCreate from '../../components/content-model.js';
import ModuleService from '../../services/screens-service.js';
import ModulesStore  from '../../store/screen-store.js';
import Translation from '../../store/internationalization-store.js';
import ContentService from '../../services/content-service.js';
import ContentStore from '../../store/content-store.js';
import SearchService from '../../services/search-service.js';
import CardHeader from '../card-header.js';
import Config from '../../classes/config.js';
import VocabObject from '../content-vocab.js';
import Card from '../card.js';
import CardBody from '../card-body.js';
import { FormattedMessage } from 'react-intl';

export default class ContentNavigation  extends React.Component {

    constructor(props){
        super();

        this.props = props;
        this.state ={
            show:false,
            modules:[],
            summary:ContentStore.getCatalogSummary(this.props.catalogUID).summary,
            search:[],
        }

        this.onOpen = props.onOpen || function(){};
        this.history = [];
    }

    componentWillMount() {
        this.baseUrl = Config.getBaseUrl();
        ContentService.fetchCatalogSummary(this.props.catalogUID)
    }

    componentDidMount() {

        ContentStore.on('ON_SUMMARY_FETCH'  , () => {
            this.setState({
                summary:ContentStore.getCatalogSummary(this.props.catalogUID).summary
            });
        });
    }

    findHistoryIndex(screenUID){

        for(var idx = 0 ; idx < this.history.length; idx++ )
        {
            if(this.history[idx].screenID == screenUID ) return idx ;
        }

        return this.history.length;
    }

    fetchModules(screenUID , isRoot , crumbTranslation){

        this.history = this.history.slice(0, this.findHistoryIndex(screenUID));

        ModuleService.getModules(screenUID).then(function(response){
            ModulesStore.modules = ModulesStore.processModules(response);
            this.onOpen(ModulesStore.modules.length > 0)
            if(isRoot)
            {
                this.history = [];
            }

            this.history.push({name:crumbTranslation , screenID:screenUID})
            this.setState({modules:ModulesStore.getArray()});
        }.bind(this));
    }


    vocabModelToggle(){
        this.setState({show:!this.state.show});
    }

    goToCatalog(catalogUID){
        window.location.hash = 'builder/catalog/'+this.props.catalogUID+'/'+catalogUID + '/' + this.state.summary.learning_ietf + '/' + this.state.summary.support_ietf;
        this.setState({search:[] , modules:[]});
        this.onOpen(true)
    }

    handelKeyDown(){
        if(this.state.isedit) return;
        clearTimeout(this.state.typingTimer);
    }

    handelKeyUp(){

        if(this.state.isedit) return;
        clearTimeout(this.state.typingTimer);

        this.setState({
            typingTimer:setTimeout(function(){

                if(this.learningText.value.length <= 0) return;
                SearchService.searchLearning(this.learningText.value , this.state.summary.learning_ietf , this.state.summary.support_ietf).then(function(response){

                    this.setState({search:response.searchResults})

                }.bind(this));

            }.bind(this), 500)
        });
    }

    render(){

        let modules = this.state.modules.map(function(module){

            let onClick = !module.catalog_uid  ? this.fetchModules.bind(this , module.screenID , false , Translation.getModuleNoIndexTranslation(module.translationID)) : this.goToCatalog.bind(this , module.catalog_uid);
            let icon    = !module.catalog_uid  ?  <i className=" zmdi-hc-2x zmdi zmdi-chevron-right"></i> : <i className="zmdi-hc-2x zmdi zmdi-format-list-bulleted"></i>;

            return <Col md={4}>
                        <div className="b-1 m-b-10"  onClick={onClick}>

                            <div  style={{width:'100%' , textAlign:'left'}} className="p-5 vert-center">
                                <p  style={{margin:0}}> {Translation.getModuleNoIndexTranslation(module.translationID)}</p>
                            </div>
                            <div  style={{width:50}} className="p-10 vert-center">
                                {icon}
                            </div>
                        </div>
                    </Col>

        }.bind(this));

        let breadcrumbs = this.history.map(function(crumb){

            let onClick = this.fetchModules.bind(this , crumb.screenID , false , crumb.name);
            return <Breadcrumb.Item onClick={onClick} >{crumb.name}</Breadcrumb.Item>

        }.bind(this));

        var VocabObjects = [];

        for(var idx = 0 ; idx < this.state.search.length; idx++)
        {
            let vocabObject = {
                picture:this.state.search[idx].picture,
                uid:this.state.search[idx].uid,
                audio:this.state.search[idx].supportAudio,
                learningAudio:this.state.search[idx].learningAudio,
                word:this.state.search[idx].word,
                originalWord:this.state.search[idx].support
            }
            console.log(vocabObject);
            VocabObjects.push(<Col md={4}><VocabObject catalogUID={this.props.catalogUID} vocab={vocabObject}/></Col>);
        }


        let title = <FormattedMessage id={"ui-2207"} defaultMessage={"From Languagenut Library"} />;

        if(sessionStorage.getItem('product') == 'pratstart')
        {
            title = <FormattedMessage id={"ui-2208"} defaultMessage={"From Pratstart Library"} />;
        }

        return   <div><Card>
                    <CardHeader className="p-b-0"><h4 className="m-l-10"><FormattedMessage id={"ui-2210"} defaultMessage={"Add Vocabulary"} /></h4></CardHeader>
                    <VocabCreate catalogUID={this.props.catalogUID} show={this.state.show} onToggle={this.vocabModelToggle.bind(this)} />
                    <CardBody padding className="p-b-0">
                        <Row className="p-0">
                            <Col sx={6} sm={6} md={4} lg={4}>
                                <Button bsStyle={'primary'} block className="m-l-5" onClick={this.fetchModules.bind(this , 247 , true , 'Topics')} >
                                  <b>{title}</b>
                                </Button> &nbsp; &nbsp;
                            </Col>
                            <Col sx={6} sm={6} md={4} lg={4}>
                                <Button bsStyle={'primary'} block onClick={this.vocabModelToggle.bind(this)}><b><FormattedMessage id={"ui-2209"} defaultMessage={"Create New Vocabulary'"} /></b></Button>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={12}>
                                <Panel collapsible expanded={this.state.modules.length > 0}>
                                    <Row>
                                        <Col>
                                         </Col>
                                    </Row>
                                    <Row>
                                        <Col md={8} className="p-r-0">
                                            <Breadcrumb className="b-1">{breadcrumbs}</Breadcrumb>
                                        </Col>
                                        <Col md={4} className="p-l-0">
                                            <div className="input-group b-1"><span className="input-group-addon zmdi icon  zmdi-search input-group-addon"></span><div className="fg-line">
                                                <input ref={ref => { this.learningText = ref; }} onKeyUp={this.handelKeyUp.bind(this)} onKeyDown={this.handelKeyDown.bind(this)}  type="text" className="search-field form-control" placeholder="" />
                                            </div>
                                            </div>
                                        </Col>
                                    </Row>
                                    <Row>
                                        {modules}
                                    </Row>
                                </Panel>
                            </Col>
                        </Row>
                    </CardBody>

            </Card>
                <Panel collapsible expanded={this.state.search.length > 0}>
                    <Card>

                        <CardBody padding className="p-b-0">
                            <Row>
                                {VocabObjects}
                            </Row>
                        </CardBody>
                    </Card>
                </Panel>
            </div>
    }

}



// WEBPACK FOOTER //
// ./src/components/layouts/content-header.js